import { parseJsonData } from "@frontend/services/helpers";
import { initDataBuilderTable } from "@frontend/group/modules/simple-table-builder/helpers";
import { getDataURLFromBlob } from "@frontend/services/helpers";
import { unFocusObjects } from "@frontend/utils";
import { FIELD_TYPE_ADDITIONAL_HTML_TABLE } from "@frontend/constants/type-fields-of-template";
const TOP_MOST_ADDITIONAL_HTML_TABLE_ORDER = -1100;

export async function drawAdditionalHtmlTable(params) {
  unFocusObjects();

  const { canvas, data } = params;
  
  canvas.getObjects().forEach((o) => {
    if (o.id.includes('add_html_')) {
      canvas.remove(o);
    }
  });

  if (data['add_html_tables']?.length) {
    const tablePromises = data['add_html_tables'].map(async (o, currentIndex) => {
      const tableObject = parseJsonData(o, null);
      const table = initDataBuilderTable(tableObject);
      const options = parseJsonData(tableObject.fieldOptions, null);
      const hasExplicitLayerOrder = Boolean(tableObject?.respectLayerOrder);
      const explicitOrder = Number.isFinite(Number(options?.Order)) ? Number(options.Order) : 0;
      let tableOuterDimension = await table.getOuterDimension();
      let tableName = `Additional Table ${currentIndex + 1}`
      if (options && options.Name && options.Name.startsWith('Markup Table') && options.Width && options.Height) {
        tableOuterDimension = {
          width: options.Width,
          height: options.Height,
        }
        tableName = options.Name;
      }
      table.styles.setRules({
        'width': `${tableOuterDimension.width}px`,
        'height': `${tableOuterDimension.height}px`,
      });
      
      if (!options) {
        return;
      }
      
      const blob = await table.toBlob();

      // Data URL, not an object URL: Chrome taints the canvas after drawing a blob: SVG with
      // a foreignObject, which breaks toDataURL (frontend exports, thumbnails).
      {
        const base64data = await getDataURLFromBlob(blob);

        fabric.Image.fromURL(base64data, function (image) {
          image.set({
            id: `add_html_table_${currentIndex}`,
            element_id: `add_html_table_${currentIndex}`,
            field_id: table.id,
            name: tableName,
            left: options.X || 0,
            top: options.Y || 0,
            angle: options.Angle || 0,
            opacity: options.opacity || 1,
            fieldType: FIELD_TYPE_ADDITIONAL_HTML_TABLE,
            order: hasExplicitLayerOrder ? explicitOrder : TOP_MOST_ADDITIONAL_HTML_TABLE_ORDER + currentIndex,
            respectLayerOrder: hasExplicitLayerOrder,
            fieldOrigin: options['Field Origin'] || '',
            tableData: tableObject.fieldOptions,
            html_table_data: data['add_html_tables'],
            linkBoxes: tableOuterDimension.linkBoxes ?? [],
            scaleX: options.ScaleX || 1,
            scaleY: options.ScaleY || 1,
            visible: data['add_html_tables_visible']?.[currentIndex] ?? true
          });

          canvas.add(image);
          canvas.renderAll();
        });
      }
    });

    await Promise.all(tablePromises);
  }
}
